import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getMaterialItemReceiveList = createAsyncThunk(
    "/user/getMaterialReceiveItem",
    async (payload = {}) => {
        try {
            const myurl = `${V_URL}/user/issue-wise-items`;
            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });
            const data = response?.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getMaterialItemReceiveSlice = createSlice({
    name: "getMaterialItemReceive",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMaterialItemReceiveList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMaterialItemReceiveList.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getMaterialItemReceiveList.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default getMaterialItemReceiveSlice.reducer;
